import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DevAdminPageClient } from "@/ui/client/DevAdminPageClient";
import { NotFoundRoute } from "./NotFoundRoute";

export const DevAdminRoute = () => {
  const { t } = useTranslation();
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    document.title = t("meta.devAdminTitle");
  }, [t]);

  const onUnavailable = useCallback(() => {
    setUnavailable(true);
  }, []);

  if (unavailable) {
    return <NotFoundRoute />;
  }

  return <DevAdminPageClient onUnavailable={onUnavailable} />;
};
